import { type Ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { routerPath } from "@/common/router";
import operatorStore from "@/store/operatorStore";
import searchConditionStore from "@/store/searchConditionStore";
import { OPERATOR_LIST_FILE_NAME } from "../constants";

/**
 * 画面の操作イベントに関するハンドラをまとめて提供する composable。
 *
 * @returns 画面イベントから呼び出す操作ハンドラ群
 */
export const useOperatorListActions = (
  editPage: Ref<boolean>,
  chainSelectValues: Ref<{ chain_code: string; name: string } | null>,
  shopSelectValues: Ref<{ shop_code: string; name: string } | null>,
  groupSelectValues: Ref<{ index: string; item: string } | null>,
  authtypeSelectValues: Ref<{ index: string; item: string } | null>,
  searchConditionId: Ref<string>,
  searchConditionName: Ref<string>,
  getCurrentPage: () => number,
) => {
  // トップレベルでrouterとstoreを取得
  const router = useRouter();
  const store = useStore();
  const route = useRoute();

  /**
   * オペレータ編集アイコン @Click
   */
  async function onClickEdit(user_id: string): Promise<void> {
    editPage.value = true;
    await searchConditionStore.setCondition({
      view_name: OPERATOR_LIST_FILE_NAME,
      conditions: new Map()
        .set("chain_code", chainSelectValues.value?.chain_code)
        .set("shop_code", shopSelectValues.value?.shop_code)
        .set("group", groupSelectValues.value?.index)
        .set("auth_type", authtypeSelectValues.value?.index)
        .set("operator_id", searchConditionId.value)
        .set("operator_name", searchConditionName.value)
        .set("page", String(getCurrentPage())),
    });
    await operatorStore.setupValue({
      user_id: user_id,
      chain_code: chainSelectValues.value?.chain_code || "",
    });
    await router.push({ path: routerPath.operatorRegister });
    store.commit("listEditOn");
  }

  /**
   * 編集画面からの戻りか判断する
   * @return true:編集、false:編集以外
   */
  function isUpdateModeBack(): boolean {
    // Vue Router 4 では path に定義されていない params は保持されないため query を使用する
    return !!route.query.searchMode;
  }

  return {
    onClickEdit,
    isUpdateModeBack,
  };
};
